import { PageHero } from "../components/PageHero";
import { Reveal, Overline } from "../components/Reveal";
import { ContactSection } from "../components/sections/ContactSection";
import { Target, Layers, ShieldCheck } from "lucide-react";

const VALUES = [
  { icon: Target, title: "Konkret ponad ozdobniki", desc: "Skupiamy się na rozwiązaniach, które mają sens biznesowy i realnie wspierają codzienną pracę firmy." },
  { icon: Layers, title: "Wszystko połączone", desc: "Strona, komunikacja i automatyzacje powinny działać razem, tworząc spójny i wygodny system." },
  { icon: ShieldCheck, title: "Jasne zasady współpracy", desc: "Stawiamy na przejrzystą ofertę, ustalony zakres działań i dobry kontakt - od pierwszej rozmowy po wdrożenie." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero
        overline="O nas"
        title="Pomagamy firmom uporządkować i"
        emphasis="rozwijać ich obecność online."
        subtitle="Veliora tworzy strony internetowe, materiały cyfrowe i proste automatyzacje dla małych i średnich firm. Stawiamy na rozwiązania, które dobrze wyglądają, ale przede wszystkim naprawdę ułatwiają codzienną pracę."
      />

      <section className="bg-[#F9F9F8] text-[#050505] py-24 md:py-32 px-6">
        <div className="max-w-6xl mx-auto">
          <Reveal><Overline>Jak pracujemy</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="text-4xl sm:text-5xl tracking-tightest leading-[1.02] font-semibold max-w-2xl mb-14 md:mb-16">
              Zasady, na których opieramy <span className="font-serif-italic font-normal" style={{ color: "var(--gold)" }}>każdą współpracę.</span>
            </h2>
          </Reveal>
          <div className="grid md:grid-cols-3 gap-5 md:gap-6">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08} className="h-full">
                <div data-testid={`value-${i}`} className="group h-full min-h-[220px] bg-white border border-black/[0.06] rounded-3xl p-8 md:p-9 flex flex-col">
                  <div className="h-[52px] w-[52px] rounded-2xl border border-black/10 flex items-center justify-center text-[#050505] mb-7 transition-colors duration-500 group-hover:border-[var(--gold)] group-hover:text-[var(--gold)]">
                    <v.icon size={22} strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-semibold tracking-tight mb-3">{v.title}</h3>
                  <p className="text-[15px] text-[#52525B] leading-relaxed">{v.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ContactSection />
    </div>
  );
}
